import { OnAuth0Logout } from 'functions/auth0Utils'
import { useAuth0 } from '@auth0/auth0-react'
import kinesisLogo from 'media/kinesis_logo.png'

import ContentFrame from 'components/Frame/ContentFrame'
import BrandColorButton from 'components/Buttons/BrandColorButton'

export default function IncorrectAccountTypeView() {

    const { logout } = useAuth0()

    return (
        <div className='fixed h-full w-full flex bg-gray-100'>
            <div className='max-w-6xl mx-auto p-4 space-y-4'>
                <img 
                    src={kinesisLogo} 
                    alt="Kinesis Logo" 
                    className="w-60 mx-auto mb-10" 
                />

                <h1 className="text-2xl font-semibold text-center text-gray-900 tracking-tight pb-4 flex-grow">
                    You appear to be lost...
                </h1>

                <div className="text-center text-gray-600 space-y-4">
                    <ContentFrame>
                        <div className="p-4 space-y-4">
                            <p>It looks like you are trying to login to the Kinesis Coach Dashboard with a Kinesis Athlete App account</p>
                            <p>Please go to Athlete App to login with your athlete account</p>
                            <p>Or create a Kinesis Coach Dashboard account using a new email</p>
                        </div>
                    </ContentFrame>
                </div>

                <div className='pt-4'>
                    <BrandColorButton
                        size="large"
                        text="Logout"
                        action={() => OnAuth0Logout(logout)}
                        className='shadow-md'
                    />
                </div>
            </div>

            <div className='absolute w-full bottom-10'>
                <p className='text-center text-gray-600'>
                    Need help? Contact us at <a href="mailto:support@kinesisintegrated.com" className="text-blue-500 underline">support@kinesisintegrated.com</a>
                </p>
            </div>
        </div>
    )
}
